/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
import videojs from "!video.js";

import { PlayerTracker } from "../../types";
import {
  PlayerDimension,
  PlayerResizeCallback,
  PlayheadTracker,
} from "../types";

import { RESIZE_CHECK_INTERVAL, UPDATE_TIME_INTERVAL } from "./consts";

// transpiling issue with video.js, !syntax with disabled webpack loader required
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved

export class PlayerTrackerVideoJS implements PlayerTracker {
  private updateTimeIntervalHandle?: number = undefined;
  private resizeCheckIntervalHandle?: number = undefined;

  private readonly onPlayerResize: PlayerResizeCallback;

  private playheadTracker: PlayheadTracker = {
    currentTime: 0,
    previousTime: 0,
    duration: 0,
  };

  private playerDimension: PlayerDimension;

  private readonly player: videojs.Player;

  constructor(player: videojs.Player, onPlayerResize: PlayerResizeCallback) {
    this.player = player;
    this.onPlayerResize = onPlayerResize;

    this.playerDimension = {
      width: this.getPlayerWidth(),
      height: this.getPlayerHeight(),
    };

    this.player.one("play", this.initialize);
  }

  get playhead() {
    return this.playheadTracker;
  }

  get dimension() {
    return this.playerDimension;
  }

  initialize = () => {
    this.clearIntervals();

    this.updateTimeIntervalHandle = window.setInterval(
      this.updateCurrentTime,
      UPDATE_TIME_INTERVAL,
    );

    this.resizeCheckIntervalHandle = window.setInterval(
      this.checkForResize,
      RESIZE_CHECK_INTERVAL,
    );
  };

  getPlayerWidth(): number {
    const rect = this.player.el().getBoundingClientRect();

    return rect.width || this.player.width();
  }

  getPlayerHeight(): number {
    const rect = this.player.el().getBoundingClientRect();

    return rect.height || this.player.height();
  }

  reset() {
    this.clearIntervals();
    this.player.one("play", this.initialize);
  }

  dispose() {
    this.clearIntervals();
  }

  private clearIntervals = () => {
    clearInterval(this.updateTimeIntervalHandle);
    clearInterval(this.resizeCheckIntervalHandle);
  };

  private updateCurrentTime = () => {
    this.playheadTracker.currentTime = this.player?.currentTime() || 0;
  };

  private checkForResize = () => {
    const currentWidth = this.getPlayerWidth();
    const currentHeight = this.getPlayerHeight();

    if (
      currentWidth !== this.playerDimension.width ||
      currentHeight !== this.playerDimension.height
    ) {
      this.playerDimension.width = currentWidth;
      this.playerDimension.height = currentHeight;
      this.onPlayerResize(currentWidth, currentHeight);
    }
  };
}
